export const SessionStorage = {
  setItem: (key: string, value: string): void => sessionStorage.setItem(key, value),
  getItem: (key: string): string | null => sessionStorage.getItem(key),
  hasKey: (key: string): boolean => Object.prototype.hasOwnProperty.call(sessionStorage, key),
  removeItem: (key: string): void => sessionStorage.removeItem(key),
};
